/*
 * Copyright (C) 2020-22  Miha Kitič<miha.kitic@mksp.si> - All rights reserved!
 */

import React, { Component, Suspense }  from "react";
import ReactDOM from "react-dom";

import Alert   from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';

import "./index.css";

// Importing lazy-loaded components
const ExperienceGallery       = React.lazy(() => import("./app_sightseeing/ExperienceGallery_tmp.js"));
const ExperienceSearchBar     = React.lazy(() => import("./app_sightseeing/ExperienceSearchBar.js"));
const ExperienceSearchResults = React.lazy(() => import("./app_sightseeing/ExperienceSearchResults.js"));
const ExperienceSelector      = React.lazy(() => import("./app_sightseeing/ExperienceSelector.js"));
const HotelRoomSelector       = React.lazy(() => import("./app_hotel/HotelRoomSelector.js"));
const HotelRoomSelector2      = React.lazy(() => import("./app_hotel/HotelRoomSelector2.js"));
const HotelSearchBar          = React.lazy(() => import("./app_hotel/HotelSearchBar.js"));
const HotelSearchResults      = React.lazy(() => import("./app_hotel/HotelSearchResults.js"));
const ImageGallery            = React.lazy(() => import("./utility/image_gallery/ImageGallery.js"));
// const SupervisorModule    = React.lazy(() => import("./app_supervisor_old/SupervisorModule.js"));
const Supervisor              = React.lazy(() => import("./app_supervisor/Supervisor.js"));
//const SupplierModule      = React.lazy(() => import("./app_supplier/SupplierModule.js"));
const Supplier                = React.lazy(() => import("./app_supplier_v2/Supplier.js"));

// Map of Components - so that they can be generated via string
//                     This map should hold a list of names for all components
//                     that we wish to expose / make available
const ComponentMap = {
    "ExperienceGallery"       : ExperienceGallery,
    "ExperienceSearchBar"     : ExperienceSearchBar,
    "ExperienceSearchResults" : ExperienceSearchResults,
    "ExperienceSelector"      : ExperienceSelector,
    "HotelRoomSelector"       : HotelRoomSelector,
    "HotelRoomSelector2"      : HotelRoomSelector2,
    "HotelSearchBar"          : HotelSearchBar,
    "HotelSearchResults"      : HotelSearchResults,
    "ImageGallery"            : ImageGallery,
    // "SupervisorModule"    : SupervisorModule,
    "SupervisorModule"        : Supervisor,
    //"SupplierModule"      : SupplierModule,
    "SupplierModule"          : Supplier,
}

//
// Generic component that we will use in order to attach Suspense to
// lazy loaded component.
class GenericComponent extends Component {
    constructor(props) {
        super(props);

        // Initial state
        this.state = {
            display_notification     : false,
            notification_type        : 'info',
            notification_message     : '',
        }

        // Binding functions
        this.notify           = this.notify.bind(this);
        this.netError         = this.netError.bind(this);
        this.hideNotification = this.hideNotification.bind(this);
    }

    /**
     * This function will display notificatons at the bottom of the screen.
     * it will be made available everywhere throughout the structure.
     * \param ntype   Notification type - determines notification color
     *                Can be standard bootstrap types (e.g. info, danger, etc.)
     * \param message Notification message (that will actually be displayed)
     */
    notify(ntype, message, other_indication) {
        let ndict  = { notification_type    : ntype,
                       display_notification : false, };

        // Only when message is give, display bottom notification
        if (message) {
            ndict.display_notification = true;
            ndict.notification_message = message;
        }

        // Finally set state
        this.setState(ndict);

        // After some time, auto-hide notification message
        let ctx = this;
        setTimeout(() => {
            ctx.state.display_notification &&
            ctx.setState({ display_notification : false })
        }, 3000);

        // Also indicate NET-ERROR if so instructed
        if      (other_indication == "NET-ERROR") { this.netError(true);  }
        else                                      { this.netError(false); }
    }

    hideNotification() {
        this.setState({ display_notification : false });
    }

    /**
     * This error indicates that we probably lost network connection.
     * should signal to template somehow that marker should be displayed. */
    netError(is_indicate_error) {
        this.props                          &&
        this.props.props                    &&
        this.props.props.net_indicator_cbk  &&
        this.props.props.net_indicator_cbk(!is_indicate_error);
    }


    // Rendering function
    render(){
        const MyComponent = this.props.component;

        const { display_notification }     = this.state;
        const { notification_type    }     = this.state;
        const { notification_message }     = this.state;

        // Define external props - we will use this props in the future to
        // be able to pass some general props throughout app while a tht esame
        // time avoid the confusion of { ...this.props }
        //
        // Fow a while we will stil pass this.props and notify_cbk for backward
        // compatibility...
        let ext_props = this.props.props;
            ext_props.notify_cbk = this.notify;

        return(
            <div>
                <Suspense fallback={ <Spinner animation="border" /> }>
                    <MyComponent {...this.props.props}
                        notify_cbk={ this.notify }
                        ext_props={ ext_props }
                    />
                </Suspense>

                { /* Here comes the footer that displays warning messages */ }
                <div className={ "notification-footer"
                              + (display_notification ? " active" : "") }
                     onClick={ e => { this.hideNotification(); }}
                >
                    <Alert variant={ notification_type }>
                        { notification_message }
                    </Alert>
                </div>
            </div>
        );
    }
}

/**
 * Generic function to generate ReactJS specified component. */
export function generateComponent(component_str, params) {
    let cobj = {

        // Internal variables -- for internal use only
        __component     : null,
        __dom_container : null,
        __props         : params.props,

        //
        // API functions

        // Function to create/Append an instance of ReactJS component
        append : function(node) {

            // When node is an array, we need to append it to provided node.
            this.__dom_container = node;
            this.__renderComponent();
        },

        // Function will reload component with new props (optional).
        // If params are not provided, old params will be used
        reload : function(new_props) {
            if (new_props) {
                for (let key in new_props) {
                    if (!new_props.hasOwnProperty(key)) { continue; }
                    this.__props[key] = new_props[key];
                }
            }

            // Reneder component
            this.__renderComponent();
        },

        // Helper function to render component
        __renderComponent : function() {
            if (this.__dom_container !=  null     &&
                this.__dom_container !== undefined) {
                ReactDOM.render(
                    React.createElement(
                        GenericComponent,
                      { props     : this.__props,
                        component : this.__component }
                    ),
                    this.__dom_container
                );
            }
        },

        // Compnent destructor function - to remove componet from container
        destroy : function() {
            this.__dom_container &&
            ReactDOM.unmountComponentAtNode(this.__dom_container);
        },
    }

    // Assign component to component object
    cobj.__component = ComponentMap[component_str];
    if (!cobj.__component) {
        console.error('Component ' + component_str + 'does not exist! '
                    + 'Please make sure that you spelled component name correctly '
                    + 'including capital letters.');
    }

    // Finally return component object to the caller
    return cobj;
}

require("expose-loader?ReactJS!./index.js");
